import React, { useEffect, useState } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import PrivateLayout from 'components/UI/PrivateLayout';

import { setHeaderToken } from '../api/utils/utils';
import { useUserStore } from '../store/useUserStore';
import routes from '../utils/routes';

const PrivateRoute = () => {
  const [hydrated, setHydrated] = useState(false);
  const { token, isCrossAppLoginInProgress } = useUserStore((s) => ({ token: s?.token }));

  const location = useLocation();
  const isLoggedIn = !!token?.accessToken;

  useEffect(() => {
    if (useUserStore.persist.hasHydrated()) {
      setHydrated(true);
    } else {
      const unsub = useUserStore.persist.onFinishHydration(() => {
        setHydrated(true);
      });
      return unsub;
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      setHeaderToken(token?.accessToken, token?.refreshToken);
    }
  }, [isLoggedIn, token]);

  if (!hydrated || isCrossAppLoginInProgress) {
    return <div>Loading...</div>;
  }

  if (!isLoggedIn) {
    return <Navigate replace state={{ from: location }} to={routes.LOGIN} />;
  }

  return (
    <PrivateLayout>
      <Outlet />
    </PrivateLayout>
  );
};

export default React.memo(PrivateRoute);
